<template>
  <div
    class="v-input"
    :class="{
      'v-input--focus': inputFocus,
      'v-input--error':
        rules(value) !== true && (inputFilled || isTouched || validate),
      'v-input--filled': inputFilled,
    }"
  >
    <div class="v-input__control">
      <label class="v-input__label body-1">{{ placeholder }}</label>
      <input
        class="body-1"
        @focus="inputFocus = true"
        @click="isTouched = true"
        @blur="inputFocus = false"
        @input="updateValue($event)"
        :value="value"
      />
      <span
        class="v-input__type"
        :class="{
          'v-input__type--hidden': required || inputFilled || inputFocus,
        }"
        >"Optional"</span
      >
    </div>

    <span class="input__border"></span>
    <small class="v-input__messages">{{
      rules(value) !== true && (inputFilled || isTouched || validate)
        ? rules(value)
        : " "
    }}</small>
    <!-- {{rules(value)===true}} -->
  </div>
</template>

<script>
export default {
  name: "mainInput",
  props: {
    rules: {
      type: Function,
      default: (val) => true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    value: String,
    validate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inputFocus: false,
      isTouched: false,
    };
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e.target.value);
    },
    // validate(){
    //   this.isTouched = true;
    // }
  },
  computed: {
    inputFilled() {
      return this.value.length;
    },
    isValid() {
      return this.rules(this.value) === true;
    },
  },
};
</script>

<style lang='scss'>
@import "../stylesheets/main.scss";
$inputPrimary: rgba(0, 0, 0, 0.3);
$inputActive: rgba(0, 0, 0, 1);
$inputError: #f00;
.v-input {
  position: relative;
  color: $inputPrimary;
  margin-bottom: 1rem;
  // border-bottom-color: $inputPrimary;
  &__control {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  input {
    flex: 1 1 auto;
    line-height: 20px;
    padding: 12px 0;
    max-width: 100%;
    min-width: 0;
    width: 100%;
    border: none;
    border-bottom: thin solid $inputPrimary;
    position: relative;
    z-index: 1;
    background: transparent;
    &::placeholder {
      color: $inputPrimary;
      font-size: 0.875rem;
    }
  }
  &__label {
    position: absolute;
    z-index: 0;
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1),
      color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    color: $inputPrimary;
    font-size: 0.875rem;
    left: 0;
    right: auto;
    transform-origin: top left;
  }
  &__messages {
    font-size: 0.75rem;
    display: inline-block;
    min-height: 0.75rem;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  &__type {
    position: absolute;
    right: 0;
    top: 12px;
    border: 1px solid #acacac;
    color: #acacac;
    font-size: 0.75rem;
    line-height: 1;
    padding: 3px 6px;
    // border-radius: 10px;
    z-index: 0;
    opacity: 1;
    transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1);
    &--hidden {
      opacity: 0;
    }
  }
  &--focus {
    .v-input__control {
      input {
        border-bottom-color: $inputActive;
      }
    }
    .v-input__label {
      color: $inputActive;
    }
  }
  &--focus,
  &--filled {
    .v-input__label {
      transform: scale(0.85) translate3d(0, -22px, 0);
    }
  }
  &--error {
    color: $inputError;
    border-color: $inputError;
    .v-input__control {
      input {
        border-bottom-color: $inputError;
      }
    }
    .v-input__label {
      color: $inputError;
      animation: 3s linear 1s schakeX;
    }
  }
}
</style>